module.exports = __webpack_public_path__ + "static/2019-header-7aa9a15e00befadfaea64c3f9bd31795.jpg";